import React from 'react';

export const Shapes = {
    StraightOpen: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <line x1="10" y1="90" x2="90" y2="10" stroke="#FFD60A" strokeWidth="8" strokeLinecap="round" />
        </svg>
    ),
    CurvedOpen: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <path d="M10,50 Q30,10 50,50 T90,50" stroke="#4CC9F0" strokeWidth="8" strokeLinecap="round" />
        </svg>
    ),
    CurvedClosed: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <path d="M20,50 Q20,20 50,20 Q80,20 80,50 Q80,80 50,80 Q20,80 20,50 Z" stroke="#4CC9F0" strokeWidth="8" strokeLinecap="round" />
        </svg>
    ),
    PolygonalOpen: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <polyline points="10,80 30,20 50,80 70,20 90,80" stroke="#70E000" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    PolygonalClosed: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <polygon points="50,10 61,40 95,40 68,60 79,90 50,70 21,90 32,60 5,40 39,40" stroke="#70E000" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Parallel: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <line x1="10" y1="30" x2="90" y2="30" stroke="#FB5607" strokeWidth="6" strokeLinecap="round" />
            <line x1="10" y1="70" x2="90" y2="70" stroke="#FB5607" strokeWidth="6" strokeLinecap="round" />
        </svg>
    ),
    Secant: () => (
        <svg viewBox="0 0 100 100" className="w-full h-full fill-none">
            <line x1="10" y1="10" x2="90" y2="90" stroke="#FB5607" strokeWidth="6" strokeLinecap="round" />
            <line x1="10" y1="90" x2="90" y2="10" stroke="#FB5607" strokeWidth="6" strokeLinecap="round" />
            <circle cx="50" cy="50" r="4" fill="#7209B7" />
        </svg>
    ),
    Triangle: ({ stroke = "#4361EE", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,15 85,85 15,85" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Quadrilateral: ({ stroke = "#F72585", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="20,20 80,20 80,80 20,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Pentagon: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,15 85,41 71,83 29,83 15,41" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Hexagon: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,10 85,27 85,73 50,90 15,73 15,27" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Trapezoid: ({ stroke = "#FF9F1C", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="30,20 70,20 85,80 15,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Rhombus: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,15 85,50 50,85 15,50" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Irregular: ({ stroke = "#70E000", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="20,20 80,20 80,50 60,60 80,90 20,90" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    IrregularTriangle: ({ stroke = "#4361EE", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="10,80 90,90 50,10" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    IrregularQuadrilateral: ({ stroke = "#F72585", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="10,20 90,10 80,90 20,70" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    IrregularPentagon: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,5 95,45 75,95 15,85 5,45" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    IrregularHexagon: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="30,5 80,15 95,50 70,95 10,80 5,40" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    // 3D Shapes
    Sphere: ({ stroke = "#4361EE", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full relative">
            <circle cx="50" cy="50" r="40" stroke={stroke} fill={fill} strokeWidth="6" />
            <ellipse cx="50" cy="50" rx="40" ry="15" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.5" />
        </svg>
    ),
    Cylinder: ({ stroke = "#F72585", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <ellipse cx="50" cy="20" rx="30" ry="10" stroke={stroke} fill={fill} strokeWidth="6" />
            <path d="M 20 20 L 20 80 A 30 10 0 0 0 80 80 L 80 20" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" />
            <ellipse cx="50" cy="80" rx="30" ry="10" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.3" />
        </svg>
    ),
    Cone: ({ stroke = "#FF9F1C", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            <path d="M 50 10 L 20 80 A 30 10 0 0 0 80 80 Z" stroke={stroke} fill={fill} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            <ellipse cx="50" cy="80" rx="30" ry="10" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.3" />
        </svg>
    ),
    CubePrism: ({ stroke = "#4CC9F0", fill = "none" }) => ( // Also technically a Square Prism
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Front face */}
            <rect x="25" y="40" width="40" height="40" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Top face */}
            <polygon points="25,40 45,20 85,20 65,40" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Right face */}
            <polygon points="65,40 85,20 85,60 65,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Hidden edges */}
            <polyline points="25,80 45,60 85,60" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="45" y1="20" x2="45" y2="60" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    TriangularPrism: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
             {/* Front Triangle */}
            <polygon points="30,80 70,80 50,40" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Top Edge */}
            <line x1="50" y1="40" x2="70" y2="20" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
            {/* Back Triangle (visible parts) */}
            <polyline points="70,80 90,60 70,20" stroke={stroke} fill="none" strokeWidth="6" strokeLinejoin="round" />
            {/* Connecting Edges */}
            <line x1="70" y1="80" x2="90" y2="60" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
            
            {/* Hidden Edges */}
            <line x1="30" y1="80" x2="50" y2="60" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="50" y1="60" x2="90" y2="60" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="50" y1="60" x2="70" y2="20" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    PentagonalPrism: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Front Pentagon */}
            <polygon points="30,80 70,80 85,55 50,30 15,55" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Back Pentagon (visible edges) */}
            <polyline points="70,80 85,60 95,40 65,15 50,30" stroke={stroke} fill="none" strokeWidth="6" strokeLinejoin="round" />
            {/* Connecting Edges */}
            <line x1="85" y1="55" x2="95" y2="40" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
            
            {/* Hidden Edges */}
            <polyline points="30,80 40,65 25,45 65,15" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="15" y1="55" x2="25" y2="45" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="40" y1="65" x2="85" y2="60" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    HexagonalPrism: ({ stroke = "#4CC9F0", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Front Hexagon */}
            <polygon points="30,85 70,85 90,55 70,25 30,25 10,55" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            
            {/* Back Hexagon (visible edges) & connecting lines */}
            <polyline points="70,85 85,75 95,45 80,15 70,25" stroke={stroke} fill="none" strokeWidth="6" strokeLinejoin="round" />
            <line x1="90" y1="55" x2="95" y2="45" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
            <line x1="30" y1="25" x2="40" y2="15" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
            <line x1="40" y1="15" x2="80" y2="15" stroke={stroke} strokeWidth="6" strokeLinecap="round" />

            {/* Hidden Edges */}
            <polyline points="30,85 45,75 55,45 40,15" stroke={stroke} fill="none" strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="10" y1="55" x2="25" y2="45" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="45" y1="75" x2="85" y2="75" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="25" y1="45" x2="55" y2="45" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    Pyramid: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Base */}
            <polygon points="20,80 45,65 85,65 60,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Visible Front Faces */}
            <polygon points="50,15 20,80 60,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,15 60,80 85,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Hidden Edge linking to back vertex */}
            <line x1="50" y1="15" x2="45" y2="65" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    TriangularPyramid: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Base (Triangle) */}
            <polygon points="20,80 80,80 50,60" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Visible Front Faces */}
            <polygon points="50,15 20,80 80,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Hidden Edge linking to back vertex */}
            <line x1="50" y1="15" x2="50" y2="60" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    SquarePyramid: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Base (Square) */}
            <polygon points="20,80 45,65 85,65 60,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Visible Front Faces */}
            <polygon points="50,15 20,80 60,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,15 60,80 85,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Hidden Edge linking to back vertex */}
            <line x1="50" y1="15" x2="45" y2="65" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    PentagonalPyramid: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Base (Pentagon) */}
            <polygon points="30,80 70,80 85,65 50,55 15,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Visible Front Faces */}
            <polygon points="50,15 30,80 70,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,15 70,80 85,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,15 15,65 30,80" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
             {/* Hidden Edges linking to back vertices */}
            <line x1="50" y1="15" x2="50" y2="55" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    ),
    HexagonalPyramid: ({ stroke = "#7209B7", fill = "none" }) => (
        <svg viewBox="0 0 100 100" className="w-full h-full">
            {/* Base (Hexagon) */}
            <polygon points="30,85 70,85 90,65 70,50 30,50 10,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Visible Front Faces */}
            <polygon points="50,10 30,85 70,85" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,10 70,85 90,65" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            <polygon points="50,10 10,65 30,85" stroke={stroke} fill={fill} strokeWidth="6" strokeLinejoin="round" />
            {/* Hidden Edges linking to back vertices */}
            <line x1="50" y1="10" x2="70" y2="50" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
            <line x1="50" y1="10" x2="30" y2="50" stroke={stroke} strokeWidth="4" strokeDasharray="4,4" opacity="0.4" />
        </svg>
    )
};
